function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgWrench = function SvgWrench(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF314F"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A30F44"
    },
    d: "M512,256c0-12.909-0.965-25.591-2.81-37.988L401.589,110.411l-20.502-5.356l-176.228,176.23 l-17.239-17.239l-82.503,77.402L274.97,511.3C407.495,501.593,512,391.004,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M125.371,276.527c-16.539,16.539-24.078,38.667-22.621,60.306c0.384,5.71,7.394,8.252,11.44,4.206 l41.86-41.86l47.309,9.463l9.463,47.309l-41.86,41.86c-4.108,4.108-1.405,11.076,4.393,11.454 c22.294,1.446,45.089-6.651,61.74-24.302c22.245-23.581,26.784-58.039,13.902-86.109l150.594-150.594 c10.452-10.452,10.452-27.396,0-37.848c-10.452-10.452-27.396-10.452-37.848,0L213.207,260.944 C184.41,247.58,149.125,252.773,125.371,276.527z M389.834,122.166c5.225,5.225,5.225,13.698,0,18.923 c-5.225,5.225-13.698,5.225-18.923,0c-5.225-5.225-5.225-13.698,0-18.923C376.136,116.941,384.607,116.941,389.834,122.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D1D3"
    },
    d: "M401.589,110.411c-0.097-0.097-0.203-0.178-0.302-0.272l-11.755,11.755 c0.098,0.093,0.205,0.176,0.302,0.272c5.225,5.225,5.225,13.698,0,18.923c-5.225,5.225-13.698,5.225-18.923,0 c-0.097-0.097-0.179-0.202-0.272-0.302L202.883,308.543l0.479,0.097l9.463,47.309l-41.86,41.86 c-4.108,4.108-1.405,11.076,4.393,11.454c22.294,1.446,45.089-6.651,61.74-24.302c22.245-23.581,26.784-58.039,13.902-86.109 l150.594-150.593C412.041,137.807,412.041,120.861,401.589,110.411z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrench, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrench.a9e6f69d.svg";
export { ForwardRef as ReactComponent };